import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../assets/logo.png';
import { resetPassword } from '../../features/auth/auth.slice';
import Spinner from '../utilities/Spinner';

const SetNewPassword = ({ setAuthType }) => {
  const [password, setPassword] = useState('');
  const { email, loading, passwordReset } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  const submitData = () => {
    if (password.length > 0) {
      dispatch(resetPassword({ email, password }));
    }
  };

  // setAuthType('resetsuccess')
  return (
    <>
      <>
        <img src={logo} alt="Postager Logo" />
        <p className="font-semibold">Set New Password</p>
      </>
      <form
        className="space-y-5 px-7 w-full pt-5"
        onSubmit={(e) => {
          e.preventDefault();
          submitData();
        }}
      >
        <p className="text-sm text-center">
          Your new password should be different from previously used password
        </p>
        <input
          type="password"
          class="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
          placeholder="New Password"
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <div className="flex flex-col justify-center items-center w-full space-y-3">
          <button
            className={`text-white   focus:ring-4 ${
              loading ? 'bg-blue-300' : 'bg-darkblue hover:bg-blue-800'
            } focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center self-center mt-5 flex justify-center`}
            type="submit"
            disabled={loading}
          >
            {loading ? <Spinner sm={true} /> : 'Reset Password'}
          </button>

          <a
            href="#"
            className="text-sm hover:underline"
            onClick={() => setAuthType('login')}
          >
            Back To Login Page
          </a>
        </div>
      </form>
    </>
  );
};

export default SetNewPassword;
